import axios from 'axios';

export const state = () => ({});

export const getters = {};

export const mutations = {};

export const actions = {
    index({ rootGetters }, { accountId = '', filterType = '', businessProfileId = '' } = {}) {
        if (!accountId) {
            const { id: loggedUserId } = rootGetters['auth/loggedUser'];

            accountId = loggedUserId;
        }

        const params = {
            account_id: accountId
        };

        if (filterType) {
            params.filter_type = filterType;
        }

        if (businessProfileId) {
            params.business_profile_id = businessProfileId;
        }

        return axios.$get('/v1/filters', {
            params
        });
    },

    async getItem(vuexContext, id) {
        return await axios.$get(`/v1/filters/${id}`);
    }
};
